import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { GoalDetails } from 'fragments';
import { SkillCard } from 'components';
import { Images, renderGoalTypes, useModal } from 'utils';
import { SessionTargetListCard } from './sessionCards';

// Expand state is owned by Session (so its "Collapse all / Expand all" toggle can drive it).
export const SessionGoalListTargets = ({ filteredListData, collapsedGoalIds, onToggleGoal }) => {
    const sessionById = useSelector((state) => state.session.sessionById);
    const notPinnedGoals = filteredListData.filter((i) => !i?.pinned) || [];
    const { open } = useModal();
    const [timerInfo, setTimerInfo] = useState([]);

    const toggleAccordion = (goalId) => onToggleGoal?.(goalId);

    return (
        <div style={{ padding: '8px 16px' }}>
            {!!notPinnedGoals?.length &&
                notPinnedGoals.map((item) => {
                    const goalId = item?.goal?.id;
                    const currentTarget = item?.goal?.targets?.find((t) => t.id === timerInfo?.find((i) => i?.id === t.id)?.id);
                    const isOpen = !collapsedGoalIds?.has(goalId);
                    return (
                        <div key={goalId} className="session-list-card-wrapper">
                            <Accordion expanded={isOpen} onChange={() => toggleAccordion(goalId)}>
                                <AccordionSummary style={{ background: currentTarget ? '#FDF4D9' : '#FFF' }}>
                                    <div className="space-between" style={{ gap: 12, width: '100%' }}>
                                        <div className="flex-align-center" style={{ gap: 12 }}>
                                            <button
                                                className="goal-link-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    open(
                                                        <GoalDetails
                                                            goalId={goalId}
                                                            requestParams={{ clientId: sessionById?.appt?.client?.id }}
                                                            clientId={sessionById?.appt?.client?.id}
                                                            viewOnly
                                                        />
                                                    );
                                                }}
                                            >
                                                {item?.goal?.name}
                                            </button>

                                            <SkillCard type={item?.goal?.type} />
                                        </div>

                                        <div className="flex-align-center" style={{ gap: 12 }}>
                                            <div className="correct-goal-box">{renderGoalTypes(item?.goal?.dataType)}</div>
                                            <button
                                                style={{ width: 36, height: 36 }}
                                                className="session-gray-action-btn-box"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleAccordion(goalId);
                                                }}
                                            >
                                                <img
                                                    style={{
                                                        transition: 'transform 0.3s ease',
                                                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    }}
                                                    src={Images.dropdownArrow}
                                                    alt="toggle"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </AccordionSummary>

                                <AccordionDetails>
                                    {item?.goal?.targets?.map((i) => (
                                        <div key={i?.id}>
                                            <SessionTargetListCard
                                                item={i}
                                                goal={item?.goal}
                                                isLast={item?.goal?.targets?.length === item?.goal?.targets?.indexOf(i) + 1}
                                                setTimerInfo={setTimerInfo}
                                                timerInfo={timerInfo}
                                            />
                                        </div>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    );
                })}
        </div>
    );
};
